// src/utils/axiosConfig.js
import axios from "axios";
import { BASE_URL } from "./auth-services";

// Create main API instance
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error?.response?.status;

        if (status === 401 || status === 403) {
            console.log("Interceptor triggered due to 401/403");

            // ✅ Get user BEFORE clearing storage
            const userDetails = JSON.parse(localStorage.getItem("UserDetails"));

            if (userDetails?.id) {
                console.log("Calling logout API with:", userDetails?.id);
                try {
                    await axios.put(
                        `${BASE_URL}/Felix/UpdateUserLoginFlagFalse/`,
                        { id: userDetails?.id }
                    );
                    console.log("Logout API called successfully");
                } catch (logoutError) {
                    console.error("Logout API failed:", logoutError);
                }
            }

            setTimeout(() => {
                // ✅ Now clear storage
                localStorage.clear();
                sessionStorage.clear();

                // ✅ Redirect to login
                // window.location.href = "/";
            }, 1000);
        }

        return Promise.reject(error);
    }
);

export default api;
